import { TbSmartHome } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const HomeIcon = (props: IconProps) => {
  return <IconBase icon={TbSmartHome} {...props} />;
};
